import React from 'react';

class FunctionGeneral {
    Producto = cellVal => {
        switch (cellVal) {
            case '134 ':
                return <div className="color-ZZ procutoCell"> CPC </div>;
            case '158 ':
                return <div className="color-AA procutoCell"> NEXT </div>;
            case '132 ':
                return <div className="color-RR procutoCell"> RENTING </div>;
            case '133 ':
                return <div className="color-LN procutoCell"> LINEAL </div>
            case '141 ':
                return <div className="color-RC procutoCell"> REFIN. CPC </div>
            case '168 ':
                return <div className="color-RN procutoCell"> REFIN. NEXT </div>
            case '166 ':
                return <div className="color-AU procutoCell"> AUTOCREDIT </div>
        }
    };

    EsferaColor = color => {
        switch (color) {
            case 'A':
                return <div className={'esferaTable color-AA'} />;
            case 'B':
                return <div className={'esferaTable color-BB'} />;
            case 'C':
                return <div className={'esferaTable color-CC'} />;
            default:
                return (
                    <div
                        className="esferaTable"
                        style={{ backgroundColor: '' }}
                    />
                );
        }
    };

    reemplazarDuplicados = optMarca => {
        var newOptMarca = [];
        optMarca.forEach(element => {
            var duplicado = false;
            for (let i = 0; i < newOptMarca.length; i++)
                if (
                    JSON.stringify(element) === JSON.stringify(newOptMarca[i])
                ) {
                    duplicado = true;
                    break;
                }
            if (!duplicado) newOptMarca.push(element);
        });
        return newOptMarca;
    };

    capitalizeText = data => {
        let dataCapitalize = '';
        for (let index in data)
            dataCapitalize +=
                data[index].charAt(0).toUpperCase() +
                data[index].toLowerCase().slice(1) +
                ' ';
        return dataCapitalize;
    };

    formatNum(nStr) {
        if (nStr === undefined || nStr === null || nStr === '') return '';

        let raw = String(nStr).trim();
        let sign = '';
        if (raw.startsWith('-')) {
            sign = '-';
            raw = raw.substring(1);
        }

        // Pick the last separator as decimal separator and strip the rest as thousands.
        const lastComma = raw.lastIndexOf(',');
        const lastDot = raw.lastIndexOf('.');
        const decimalIndex = Math.max(lastComma, lastDot);

        let integerPart = raw;
        let decimalPart = '';

        if (decimalIndex > -1) {
            integerPart = raw.substring(0, decimalIndex);
            decimalPart = raw.substring(decimalIndex + 1);
        }

        integerPart = integerPart.replace(/[^\d]/g, '');
        decimalPart = decimalPart.replace(/[^\d]/g, '');

        if (integerPart === '') integerPart = '0';

        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(integerPart)) {
            integerPart = integerPart.replace(rgx, '$1' + '.' + '$2');
        }

        return sign + integerPart + (decimalPart.length > 0 ? ',' + decimalPart : '');
    }

    addCPCFeeNumber = (dataProyeccion, dataContrato, rowSelect) => {
        try {
            var fechainicial =
                dataContrato.FormalizationDate.split('T')[0].split('-');
            var fechaFinal =
                rowSelect.ProductBoxId === '132 '
                    ? dataContrato.endDateRenting.split('T')[0].split('-')
                    : dataContrato.ExpirationDate.split('T')[0].split('-');
            var _fechaActual = new Date();
            var fechaActual = [
                _fechaActual.getFullYear(),
                1 + _fechaActual.getMonth(),
                _fechaActual.getDate(),
            ];
            var meses =
                (fechaActual[0] - fechainicial[0]) * 12 +
                (fechaActual[1] - fechaFinal[1]);
            for (var i = dataProyeccion.length - 1; i >= 0; ) {
                var fechaproyeccion =
                    dataProyeccion[i].ReferenceDate.split('T')[0].split('-');
                var meses =
                    (fechaFinal[0] - fechaproyeccion[0]) * 12 +
                    (fechaFinal[1] - fechaproyeccion[1]);
                dataProyeccion[i].FeeNumber =
                    (rowSelect.ProductBoxId === '132 '
                        ? dataContrato.TermMonthPeriodCuotas
                        : dataContrato.TermMonthPeriodOption) - meses;
                i = i - 1;
            }
        } catch {
            return dataProyeccion;
        }
        return dataProyeccion;
    };

    formatFecha(dataFecha) {
        return dataFecha[2] + '/' + dataFecha[1] + '/' + dataFecha[0];
    }

    fechainicial = () => {
        let fechaActual = new Date();
        let fechaReturn =
            (fechaActual.getDate() < 10 ? '0' : '') +
            fechaActual.getDate() +
            '/';
        fechaReturn =
            fechaReturn +
            (fechaActual.getMonth() + 1 < 10 ? '0' : '') +
            (fechaActual.getMonth() + 1) +
            '/';
        fechaReturn = fechaReturn + fechaActual.getFullYear();
        return fechaReturn;
    };

    ordenarLista = (list, type, option) => {
        switch (option) {
            case 'SC': //Score/Color Cliente
                list.sort(function (a, b) {
                    if (a.CustomerVehicleCategory === null) return 1;
                    else if (b.CustomerVehicleCategory === null) return -1;
                    var _a = a.CustomerVehicleCategory;
                    var _b = b.CustomerVehicleCategory;
                    if (_a > _b) return 1;
                    else if (_a < _b) return -1;
                    else return 0;
                });
                break;
            case 'SV': //Score/Color Vehiculo
                list.sort(function (a, b) {
                    if (a.CustomerVehicleCategory === null) return 1;
                    else if (b.CustomerVehicleCategory === null) return -1;
                    var _a =
                        a.CustomerVehicleCategory[1] +
                        a.CustomerVehicleCategory[0];
                    var _b =
                        b.CustomerVehicleCategory[1] +
                        b.CustomerVehicleCategory[0];
                    if (_a > _b) return 1;
                    else if (_a < _b) return -1;
                    else return 0;
                });
                break;
            case 'PC': // producto comercial
                list.sort(function (a, b) {
                    if (a.ProductBoxId === null) return 1;
                    else if (b.ProductBoxId === null) return -1;
                    var _a =
                        a.ProductBoxId === '158 '
                            ? 'next'
                            : a.ProductBoxId === '134 '
                            ? 'CPC'
                            : a.ProductBoxId === '132 '
                            ? 'RENTING'
                            :a.ProductBoxId === '133 '
                            ? 'LINEAL'
                            :a.ProductBoxId === '141 '
                            ? 'REFINANCIACION CPC'
                            :a.ProductBoxId === '168 '
                            ? 'REFINANCIACION NEXT'
                            :a.ProductBoxId === '166 '
                            ? 'AUTOCREDIT'
                            : '';
                    var _b =
                        b.ProductBoxId === '158 '
                            ? 'next'
                            : b.ProductBoxId === '134 '
                            ? 'CPC'
                            : b.ProductBoxId === '132 '
                            ? 'RENTING'
                            : b.ProductBoxId === '133 '
                            ? 'LINEAL'
                            : b.ProductBoxId === '141 '
                            ? 'REFINANCIACION CPC'
                            : b.ProductBoxId === '168 '
                            ? 'REFINANCIACION NEXT'
                            : b.ProductBoxId === '166 '
                            ? 'AUTOCREDIT'
                            : '';

                    if (_a > _b) return 1;
                    else if (_a < _b) return -1;
                    else return 0;
                });
                break;
            case 'FV': //fecha de vencimiento
                list.sort(function (a, b) {
                    if (a.ExpirationDate === null) return 1;
                    else if (b.ExpirationDate === null) return -1;
                    a = a.ExpirationDate.split('/');
                    b = b.ExpirationDate.split('/');
                    if (
                        new Date(a[2], a[1] - 1, a[0]) >
                        new Date(b[2], b[1] - 1, b[0])
                    )
                        return 1;
                    else if (
                        new Date(a[2], a[1] - 1, a[0]) <
                        new Date(b[2], b[1] - 1, b[0])
                    )
                        return -1;
                    else return 0;
                });
                break;
            case 'FI': //fecha IPO
                list.sort(function (a, b) {
                    if (a.IPODate === null) return 1;
                    else if (b.IPODate === null) return -1;
                    a = a.IPODate.split('/');
                    b = b.IPODate.split('/');

                    if (
                        new Date(a[2], a[1] - 1, a[0]) >
                        new Date(b[2], b[1] - 1, b[0])
                    )
                        return 1;
                    else if (
                        new Date(a[2], a[1] - 1, a[0]) <
                        new Date(b[2], b[1] - 1, b[0])
                    )
                        return -1;
                    else return 0;
                });
                break;
            case 'AO': //asesor original -> SellerContractsFullName
                list.sort(function (a, b) {
                    if (a.SellerContractsFullName === null) return 1;
                    else if (b.SellerContractsFullName === null) return -1;

                    if (a.SellerContractsFullName > b.SellerContractsFullName)
                        return 1;
                    else if (
                        a.SellerContractsFullName < b.SellerContractsFullName
                    )
                        return -1;
                    else return 0;
                });
                break;
            case 'AA': // asesor asignado -> VendedorAsignado
                list.sort(function (a, b) {
                    if (a.VendedorAsignado === null) return 1;
                    else if (b.VendedorAsignado === null) return -1;
                    if (a.VendedorAsignado > b.VendedorAsignado) return 1;
                    else if (a.VendedorAsignado < b.VendedorAsignado) return -1;
                    else return 0;
                });
                break;
        }
        if (type === 'desc') return list.reverse();
        else return list;
    };
    
    Exportar(table, metrica) {
        var downloadLink;
        downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        var uri = 'data:application/vnd.ms-excel;base64; charset=UTF-8,',
            template =
                '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64 = function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format = function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            };

        var name = metrica + '.xls';
        var ctx = {
            worksheet: name || 'Worksheet',
            table: table.innerHTML,
            dataType: 'String',
        };
        downloadLink.href = uri + base64(format(template, ctx));
        downloadLink.download = name;
        downloadLink.click();
    }

    tableCreate(data, metrica) {
        var tbl = document.createElement('table');
        var tblBody = document.createElement('tbody');
        var keys_ = Object.keys(data[0]);
        var row_ = document.createElement('tr');
        var cell = document.createElement('td');
        keys_.forEach(element => {
            cell = document.createElement('td');
            cell.appendChild(
                document.createTextNode(
                    element !== null ? element.toString() : ''
                )
            );
            row_.appendChild(cell);
        });
        tblBody.appendChild(row_);
        data.forEach(row => {
            row_ = document.createElement('tr');
            keys_.forEach(element => {
                cell = document.createElement('td');
                cell.appendChild(
                    document.createTextNode(
                        row[element] !== null ? row[element].toString() : ''
                    )
                );
                row_.appendChild(cell);
            });
            tblBody.appendChild(row_);
        });
        tbl.appendChild(tblBody);
        new FunctionGeneral().Exportar(tbl, metrica);
    }

    purchaseIrrevocableStyle = value => {
        switch (value) {
            case 'S':
                return <div className="color-ZZ">Sí</div>;
            case 'N':
                return <div className="color-AA">No</div>;
           
        }
    };

}

export default FunctionGeneral;
